import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { DeactiveUserLogRoutes } from '../../../routes/HomeRoutes/DeactiveUserLogRoutes';

export const DeactiveUserLog = (props) => {
  return <SwitchRoute routes={DeactiveUserLogRoutes} />;
};
